<template>
    <div id="app">
        <ejs-tab id="element" ref='productsTab'>
            <e-tabitems>
                <e-tabitem :header='headerText2' :content='currencyTemplate'></e-tabitem>
                <e-tabitem :header='headerText1' :content='statesTemplate'></e-tabitem>
                <e-tabitem :header='headerText8' :content='priceAreaTemplate'></e-tabitem>
                <e-tabitem :header='headerText7' :content='suppliersTemplate'></e-tabitem>
                <e-tabitem :header='headerText3' :content='defaultMechanismTemplate'></e-tabitem>
                <e-tabitem :header='headerText4' :content='referenceTypesTemplate'></e-tabitem>
                <e-tabitem :header='headerText5' :content='sectorsTemplate'></e-tabitem>
                <e-tabitem :header='headerText6' :content='strategiesTemplate'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import currenciesForm from '@/views/administration/general/Currency.vue';
    import referencePricesForm from '@/views/administration/general/ReferenceType.vue';
    import sectorsForm from '@/views/administration/general/Sector.vue';
    import countriesForm from '@/views/administration/general/State.vue';
    import strategiesForm from '@/views/administration/general/StrategyType.vue';
    import defaultMechanismsForm from '@/views/administration/general/DefaultMechanism.vue';
    import suppliersForm from '@/views/administration/general/Supplier.vue';
    import priceAreaForm from '@/views/administration/general/PriceArea.vue';
    import { DatePickerComponent, CalendarComponent, DatePickerPlugin, CalendarPlugin } from '@syncfusion/ej2-vue-calendars';

    Vue.use(TabPlugin);
    Vue.use(TabPlugin);
    Vue.component(DatePickerPlugin.name, DatePickerComponent);
    Vue.component(CalendarPlugin.name, CalendarComponent);

    export default {
        name: 'app',
        data: function () {
            return {
                headerText1: { text: 'Countries' },
                headerText8: { text: 'Price Areas' },
                headerText2: { text: 'Currencies' },
                headerText3: { text: 'Default Mechanisms' },
                headerText4: { text: 'Price References' },
                headerText5: { text: 'Sectors' },
                headerText6: { text: 'Strategies' },
                headerText7: { text: 'Suppliers' },
                propsData: null,
                statesTemplate: function () {
                    return {
                        template: {
                            extends: countriesForm
                        }
                    }
                },
                priceAreaTemplate: function () {
                    return {
                        template: {
                            extends: priceAreaForm
                        }
                    }
                },
                currencyTemplate: function () {
                    return {
                        template: {
                            extends: currenciesForm
                        }
                    }
                },
                defaultMechanismTemplate: function () {
                    return {
                        template: {
                            extends: defaultMechanismsForm
                        }
                    }
                },
                referenceTypesTemplate: function () {
                    return {
                        template: {
                            extends: referencePricesForm
                        }
                    }
                },
                sectorsTemplate: function () {
                    return {
                        template: {
                            extends: sectorsForm
                        }
                    }
                },
                strategiesTemplate: function () {
                    return {
                        template: {
                            extends: strategiesForm
                        }
                    }
                },
                suppliersTemplate: function () {
                    return {
                        template: {
                            extends: suppliersForm
                        }
                    }
                }
            }
        },
        mounted: function () {
         
            if (!this.$store.state.permissions["Permissions.Currencies.View"]) {
                this.$refs.productsTab.hideTab(0);
            }
            if (!this.$store.state.permissions["Permissions.State.View"]) {
                this.$refs.productsTab.hideTab(1);
            }
            if (!this.$store.state.permissions["Permissions.PriceArea.View"]) {
                this.$refs.productsTab.hideTab(2);
            }
            if (!this.$store.state.permissions["Permissions.Suppliers.View"]) {
                this.$refs.productsTab.hideTab(3);
            }
            if (!this.$store.state.permissions["Permissions.DefaultMechanisms.View"]) {
                this.$refs.productsTab.hideTab(4);
            }
            if (!this.$store.state.permissions["Permissions.ReferenceTypes.View"]) {
                this.$refs.productsTab.hideTab(5);
            }
            if (!this.$store.state.permissions["Permissions.Sectors.View"]) {
                this.$refs.productsTab.hideTab(6);
            }
            if (!this.$store.state.permissions["Permissions.StrategyTypes.View"]) {
                this.$refs.productsTab.hideTab(7);
            }
          
        },
    }
</script>

<style>
    .required-input.e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
        font-weight: bold;
    }
</style>